var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightImgV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 822,
    height: 410,
    viewBox: "0 0 822 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.312 1V408",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.07995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.312 1V408",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.07995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.312 1V408",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.07995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.312 1V408",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.07995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.312 1V408",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.07995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M818.876 110.148H1",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.07995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.876 258.918H1",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.07995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.876 407.646H1",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.07995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5459 407.645C15.2581 405.538 131.266 263.132 230.4 263.132C329.534 263.132 360.75 352.857 486.461 367.608C612.171 382.358 652.246 207.459 818.875 177.958",
    stroke: "url(#paint0_linear_10235_10559)",
    strokeWidth: 3.99981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5459 209.566C11.5459 209.566 169.232 384.466 297.895 391.841C426.558 399.216 468.743 208.513 562.604 201.138C656.465 193.762 735.561 296.384 818.875 296.384",
    stroke: "url(#paint1_linear_10235_10559)",
    strokeWidth: 5.33309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M701.898 240.079C701.898 242.798 701.09 245.456 699.577 247.716C698.064 249.977 695.914 251.738 693.399 252.776C690.883 253.815 688.116 254.084 685.447 253.551C682.778 253.017 680.328 251.705 678.407 249.779C676.485 247.853 675.179 245.401 674.653 242.733C674.127 240.065 674.405 237.302 675.453 234.792C676.5 232.282 678.269 230.139 680.536 228.635C682.803 227.13 685.466 226.332 688.188 226.34C689.993 226.334 691.782 226.686 693.451 227.375C695.12 228.064 696.635 229.077 697.91 230.354C699.185 231.632 700.193 233.149 700.878 234.818C701.562 236.487 701.909 238.275 701.898 240.079Z",
    fill: "url(#paint2_linear_10235_10559)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M418.501 344.429C418.509 346.798 417.814 349.116 416.502 351.09C415.191 353.064 413.323 354.604 411.134 355.517C408.946 356.429 406.536 356.672 404.209 356.215C401.882 355.758 399.744 354.621 398.064 352.949C396.384 351.277 395.239 349.144 394.773 346.822C394.308 344.499 394.542 342.09 395.448 339.9C396.353 337.711 397.889 335.839 399.86 334.522C401.831 333.205 404.149 332.502 406.52 332.502C409.691 332.502 412.731 333.757 414.977 335.993C417.223 338.228 418.49 341.262 418.501 344.429Z",
    fill: "url(#paint3_linear_10235_10559)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M688.187 305.614C724.579 305.614 754.08 276.273 754.08 240.079C754.08 203.885 724.579 174.544 688.187 174.544C651.796 174.544 622.295 203.885 622.295 240.079C622.295 276.273 651.796 305.614 688.187 305.614Z",
    fill: "url(#paint4_radial_10235_10559)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M406.521 388.132C430.797 388.132 450.477 368.565 450.477 344.428C450.477 320.291 430.797 300.725 406.521 300.725C382.244 300.725 362.564 320.291 362.564 344.428C362.564 368.565 382.244 388.132 406.521 388.132Z",
    fill: "url(#paint5_radial_10235_10559)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10235_10559)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.378 301.606C231.378 328.512 242.066 354.316 261.092 373.341C280.118 392.367 305.923 403.055 332.83 403.055V420.577C301.276 420.577 271.014 408.043 248.702 385.732C226.389 363.42 213.854 333.159 213.854 301.606H231.378Z",
    fill: "url(#paint6_linear_10235_10559)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.568 229.871C385.542 210.845 359.737 200.157 332.83 200.157V182.634C364.384 182.634 394.647 195.169 416.959 217.48C439.271 239.792 451.806 270.053 451.806 301.606C451.806 333.159 439.271 363.42 416.959 385.731C394.647 408.043 364.384 420.577 332.83 420.577V403.055C359.737 403.055 385.542 392.366 404.568 373.341C423.594 354.316 434.283 328.512 434.283 301.606C434.283 274.7 423.594 248.896 404.568 229.871Z",
    fill: "url(#paint7_linear_10235_10559)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.83 200.157C305.923 200.157 280.119 210.845 261.092 229.871C242.066 248.896 231.378 274.7 231.378 301.606H213.854C213.854 270.053 226.389 239.792 248.702 217.48C271.014 195.169 301.276 182.634 332.83 182.634V200.157Z",
    fill: "url(#paint8_linear_10235_10559)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.83 285.741C239.074 332.666 270.017 377.805 316.943 386.561C363.87 395.317 409.011 364.376 417.767 317.451C426.524 270.526 395.581 225.387 348.654 216.631C301.727 207.874 256.587 238.816 247.83 285.741ZM316.358 389.699C267.698 380.619 235.613 333.813 244.693 285.156C253.773 236.498 300.58 204.413 349.24 213.493C397.899 222.573 429.985 269.378 420.905 318.036C411.825 366.694 365.018 398.778 316.358 389.699Z",
    fill: "url(#paint9_linear_10235_10559)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M330.5 226.345C349.891 226.345 365.61 210.698 365.61 191.396C365.61 172.094 349.891 156.446 330.5 156.446C311.109 156.446 295.39 172.094 295.39 191.396C295.39 210.698 311.109 226.345 330.5 226.345Z",
    fill: "url(#paint10_radial_10235_10559)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M332.798 446.765C352.189 446.765 367.908 431.118 367.908 411.816C367.908 392.514 352.189 376.867 332.798 376.867C313.407 376.867 297.688 392.514 297.688 411.816C297.688 431.118 313.407 446.765 332.798 446.765Z",
    fill: "url(#paint11_radial_10235_10559)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M222.584 337.225C241.975 337.225 257.694 321.578 257.694 302.276C257.694 282.974 241.975 267.327 222.584 267.327C203.193 267.327 187.474 282.974 187.474 302.276C187.474 321.578 203.193 337.225 222.584 337.225Z",
    fill: "url(#paint12_radial_10235_10559)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.706 222.394L194.45 211.506L198.454 226.451L183.706 222.394ZM205.033 251.003L190.708 265.52L171.044 260.11L166.372 242.675L186.036 248.084L200.361 233.568L205.033 251.003ZM160.46 220.614L175.209 224.671L164.465 235.558L160.46 220.614ZM182.535 226.521L197.283 230.579L186.54 241.466L182.535 226.521ZM182.291 242.604L167.542 238.547L178.286 227.66L182.291 242.604ZM191.372 208.517L178.79 221.042L161.631 216.486L174.118 203.606L191.372 208.517ZM154.877 216.77L167.367 263.384L191.852 269.79L209.854 252L197.364 205.386L172.878 198.98L154.877 216.77Z",
    fill: "url(#paint13_linear_10235_10559)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M473.714 188.559L473.043 189.617L463.388 223.122L463.629 223.558L481.839 218.849L473.714 188.559Z",
    fill: "url(#paint14_linear_10235_10559)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M473.714 188.562L450.721 209.883L463.634 223.562L468.318 207.299L473.714 188.562Z",
    fill: "url(#paint15_linear_10235_10559)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M462.782 226.503L462.523 226.684L459.084 238.619L459.114 239.233L481.002 221.804L462.782 226.503Z",
    fill: "url(#paint16_linear_10235_10559)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M459.113 239.233L462.781 226.503L449.868 212.83L459.113 239.233Z",
    fill: "url(#paint17_linear_10235_10559)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M463.627 223.558L481.837 218.849L468.313 207.295L463.627 223.558Z",
    fill: "url(#paint18_linear_10235_10559)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M450.717 209.882L463.629 223.558L468.315 207.296L450.717 209.882Z",
    fill: "url(#paint19_linear_10235_10559)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.745 259.813L311.331 262.222C311.331 262.222 307.603 259.492 306.082 256.655C304.764 254.196 304.447 250.276 304.447 250.276C304.447 250.276 307.971 251.22 309.569 250.725C311.037 250.271 311.497 249.932 311.497 249.932C311.497 249.932 310.863 255.708 313.745 259.813ZM365.647 299.241C366.127 296.254 364.239 292.134 364.239 292.134C368.153 292.375 369.625 296.087 369.625 299.177C369.625 302.268 367.632 305.771 365.228 308.036C362.824 310.3 362.276 312.808 362.276 312.808C361.331 310.223 361.83 308.869 362.393 307.338C362.916 305.92 363.494 304.351 363.031 301.512C362.565 298.609 360.606 296.369 358.738 294.842C357.863 295.367 356.883 296.06 355.791 296.83C349.048 301.595 338.086 309.339 321.782 298.75C306.001 288.5 301.886 290.197 299.179 291.313C298.637 291.536 298.152 291.737 297.64 291.813C299.13 291.915 300.611 292.126 302.07 292.447C302.07 292.447 294.963 295.602 294 301.507C293.537 304.347 294.115 305.916 294.637 307.334C295.201 308.864 295.7 310.219 294.754 312.804C294.754 312.804 294.208 310.305 291.805 308.038C289.401 305.771 287.408 302.27 287.408 299.179C287.408 296.089 288.886 292.381 292.8 292.14C292.8 292.14 290.911 296.261 291.392 299.247C291.392 299.247 292.978 293.722 294.905 292.242L294.053 290.072C298.538 287.626 303.325 285.782 308.292 284.588C308.292 284.588 303.619 282.456 295.306 285.458L293.975 280.804C303.02 276.414 312.468 274.658 322.575 274.423C322.575 274.423 311.505 271.496 297.638 275.709C297.618 275.241 297.575 274.906 297.541 274.638L297.541 274.638C297.476 274.133 297.442 273.87 297.655 273.422C297.82 273.109 298.039 272.828 298.303 272.592C298.505 272.422 301.884 269.724 311.863 268.659C311.863 268.659 307.891 267.044 300.941 268.293C301.226 266.012 301.908 263.78 304.77 263.167C307.431 262.607 308.633 263.189 310.589 264.137C311.51 264.584 312.598 265.111 314.085 265.638C316.003 266.318 318.836 266.327 321.462 266.336C322.549 266.34 323.599 266.344 324.536 266.394C315.873 265.481 311.758 262.654 311.758 262.654C311.758 262.654 313.467 260.494 315.515 259.848C316.151 259.647 316.853 259.568 317.621 259.48C319.328 259.286 321.36 259.055 323.712 257.381C327.121 254.952 330.048 255.216 330.048 255.216C330.048 255.216 332.969 254.952 336.385 257.381C338.74 259.055 340.773 259.286 342.479 259.48C343.247 259.567 343.949 259.647 344.583 259.848C346.27 260.377 347.725 261.937 348.187 262.472C349.252 262.117 350.345 262.02 352.011 262.372C354.562 262.91 355.566 266.409 355.958 268.78C353.714 268.314 348.115 267.619 336.861 268.659C336.861 268.659 349.501 269.35 356.849 272.573C357.614 273.039 358.616 273.757 358.961 274.486C359.546 275.723 359.39 279.094 359.39 279.094L362.928 280.81L361.78 285.534C361.78 285.534 347.985 279.237 328.452 280.954C328.452 280.954 348.614 280.669 362.105 288.845L363.065 289.532L362.025 292.158C364.002 293.518 365.647 299.241 365.647 299.241ZM315.298 347.925C313.442 347.342 311.899 345.384 311.899 345.384C311.899 345.384 317.187 341.746 328.45 341.746C339.712 341.746 345.006 345.384 345.006 345.384C345.006 345.384 343.461 347.354 341.607 347.939C341.032 348.12 340.397 348.193 339.702 348.271C338.159 348.447 336.323 348.656 334.191 350.171C331.101 352.368 328.454 352.129 328.454 352.129C328.454 352.129 325.803 352.354 322.714 350.157C320.582 348.64 318.744 348.431 317.2 348.256L317.2 348.256C316.507 348.177 315.873 348.105 315.298 347.925ZM374.469 283.735C370.401 281.456 363.726 281.019 363.726 281.019L362.65 285.839C369.361 288.608 373.085 296.148 373.085 296.148C373.085 296.148 373.384 295.378 374.823 293.681C376.39 291.842 381.427 290.252 381.427 290.252C381.427 290.252 377.991 285.702 374.469 283.735ZM364.051 340.661C364.051 340.661 363.832 341.158 363.714 342.617C363.583 344.204 365.192 347.282 365.192 347.282C365.192 347.282 361.484 347.797 358.929 347.077C356.562 346.409 353.966 344.412 353.032 343.648C352.71 343.82 352.366 343.946 352.01 344.022C349.346 344.582 348.144 343.998 346.19 343.049C345.271 342.603 344.186 342.076 342.703 341.548C338.069 339.901 328.452 339.866 328.452 339.866C328.452 339.866 318.839 339.887 314.204 341.542C312.727 342.07 311.645 342.595 310.729 343.039C308.767 343.991 307.566 344.573 304.897 344.016C302.033 343.413 301.424 340.88 301.14 338.597C308.084 339.848 311.867 337.728 311.867 337.728C301.888 336.657 298.512 333.963 298.307 333.796C298.043 333.56 297.824 333.278 297.659 332.964C297.396 332.406 297.419 331.998 297.468 331.136C297.479 330.939 297.491 330.719 297.502 330.468C311.366 334.681 322.584 331.964 322.584 331.964C312.476 331.729 303.029 329.974 293.984 325.581L295.364 320.414C304.03 322.587 308.3 321.798 308.3 321.798C303.334 320.604 298.547 318.76 294.064 316.314L295.151 313.563C309.159 319.286 347.764 319.286 361.772 313.563L363.076 316.86L362.115 317.546C348.629 325.724 328.463 325.438 328.463 325.438C347.985 327.157 361.78 320.858 361.78 320.858L362.931 325.585L359.393 327.304C359.393 327.304 359.84 331.731 359.256 332.968C358.91 333.698 357.909 334.415 357.144 334.881C349.796 338.115 336.861 337.743 336.861 337.743C348.124 338.785 353.622 338.902 355.871 338.436C358.49 339.527 361.24 340.276 364.051 340.661ZM291.324 308.782C284.622 311.568 276.656 308.868 276.656 308.868C276.656 308.868 276.989 309.616 277.175 311.842C277.38 314.254 274.927 318.938 274.927 318.938C274.927 318.938 280.566 319.721 284.454 318.626C288.951 317.36 293.973 312.95 293.973 312.95L291.324 308.782ZM307.533 302.12C307.533 302.12 305.742 306.413 309.247 308.138C312.753 309.863 321.565 308.988 321.565 308.988C321.565 308.988 313.926 303.359 307.533 302.12ZM348.919 310.862C351.871 310.106 351.184 306.535 351.184 306.535L351.186 306.535C346.102 306.467 339.373 309.558 339.373 309.558C339.373 309.558 345.967 311.618 348.919 310.862Z",
    fill: "url(#paint20_linear_10235_10559)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.078 357.702L366.584 363.523V365.931H378.344V363.091H371.342L373.913 360.169C374.521 359.561 375.067 358.984 375.55 358.439C376.033 357.885 376.446 357.344 376.789 356.814C377.132 356.284 377.393 355.75 377.572 355.212C377.759 354.675 377.853 354.118 377.853 353.541C377.853 352.52 377.638 351.647 377.21 350.923C376.781 350.198 376.15 349.641 375.316 349.251C374.482 348.861 373.45 348.667 372.218 348.667C371.018 348.667 369.97 348.924 369.074 349.438C368.178 349.945 367.48 350.626 366.981 351.484C366.898 351.626 366.821 351.771 366.752 351.918C366.406 352.652 366.233 353.45 366.233 354.312H369.904C369.904 353.775 369.993 353.295 370.173 352.875C370.352 352.446 370.609 352.111 370.944 351.869C371.279 351.628 371.681 351.507 372.148 351.507C372.584 351.507 372.955 351.6 373.259 351.788C373.563 351.975 373.792 352.243 373.948 352.594C374.112 352.945 374.194 353.373 374.194 353.88C374.194 354.192 374.124 354.534 373.983 354.909C373.843 355.275 373.617 355.684 373.305 356.136C373.001 356.588 372.592 357.11 372.078 357.702ZM365.096 349.979C365.034 350.076 364.973 350.175 364.914 350.275C364.32 351.29 363.977 352.39 363.873 353.547L365.096 349.979Z",
    fill: "url(#paint21_linear_10235_10559)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.595 361.583L361.218 348.912H365.462L359.629 365.932H355.549L349.751 348.912H353.983L357.595 361.583ZM367.258 351.054L366.24 354.026C366.282 353.102 366.529 352.254 366.981 351.484C367.068 351.335 367.16 351.192 367.258 351.054Z",
    fill: "url(#paint22_linear_10235_10559)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M493.216 337.296C493.986 332.253 490.067 329.542 484.71 327.733L486.448 320.901L482.204 319.865L480.512 326.517C479.397 326.244 478.251 325.987 477.112 325.732L478.816 319.036L474.576 318L472.836 324.83C471.913 324.624 471.007 324.42 470.127 324.206L470.132 324.184L464.28 322.752L463.151 327.194C463.151 327.194 466.299 327.901 466.233 327.945C467.951 328.365 468.262 329.48 468.21 330.364L466.231 338.147C466.349 338.177 466.502 338.219 466.672 338.286C466.53 338.251 466.38 338.214 466.223 338.177L463.448 349.081C463.238 349.592 462.705 350.36 461.504 350.068C461.546 350.129 458.419 349.314 458.419 349.314L456.312 354.075L461.835 355.424C462.862 355.676 463.869 355.941 464.86 356.189L463.104 363.1L467.343 364.136L469.082 357.299C470.24 357.607 471.364 357.891 472.464 358.159L470.731 364.964L474.975 366L476.73 359.103C483.967 360.445 489.408 359.904 491.698 353.489C493.543 348.325 491.606 345.346 487.799 343.403C490.572 342.776 492.66 340.989 493.217 337.297L493.216 337.296L493.216 337.296ZM483.52 350.621C482.209 355.785 473.336 352.994 470.46 352.294L472.79 343.138C475.666 343.842 484.891 345.235 483.52 350.621H483.52ZM484.833 337.222C483.636 341.919 476.252 339.533 473.856 338.947L475.969 330.644C478.364 331.229 486.079 332.322 484.833 337.222H484.833Z",
    fill: "url(#paint23_linear_10235_10559)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10235_10559",
    x1: 5.2182,
    y1: 292.802,
    x2: 825.203,
    y2: 292.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242974,
    stopColor: "#23A9F1",
    stopOpacity: 0.242974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269901,
    stopColor: "#27AAF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518282,
    stopColor: "#51BAF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546701,
    stopColor: "#54BBF7",
    stopOpacity: 0.418752
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10235_10559",
    x1: 3.10897,
    y1: 296.426,
    x2: 827.312,
    y2: 296.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314173,
    stopColor: "#25A9F1",
    stopOpacity: 0.25366
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341338,
    stopColor: "#26AAF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54369,
    stopColor: "#52BAF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562539,
    stopColor: "#53BBF7",
    stopOpacity: 0.570502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10235_10559",
    x1: 674.436,
    y1: 240.079,
    x2: 701.898,
    y2: 240.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10235_10559",
    x1: 394.582,
    y1: 344.429,
    x2: 418.501,
    y2: 344.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10235_10559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(687.418 250.496) scale(66.0953 66.0323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90D2FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72C7FB",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#57BCF7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40B3F4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2CACF2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1CA6F0",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#10A1EE",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#079EED",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#029CEC",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10235_10559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(405.041 355.649) scale(44.0559 44.014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90D2FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72C7FB",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#57BCF7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40B3F4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2CACF2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1CA6F0",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#10A1EE",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#079EED",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#029CEC",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10235_10559",
    x1: 213.839,
    y1: 361.1,
    x2: 332.83,
    y2: 361.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10235_10559",
    x1: 307.072,
    y1: 197.492,
    x2: 418.078,
    y2: 389.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10235_10559",
    x1: 213.839,
    y1: 242.112,
    x2: 332.83,
    y2: 242.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10235_10559",
    x1: 243.14,
    y1: 301.603,
    x2: 422.426,
    y2: 301.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10235_10559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.283 198.383) scale(35.213 35.2117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90D2FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72C7FB",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#57BCF7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40B3F4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2CACF2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1CA6F0",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#10A1EE",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#079EED",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#029CEC",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10235_10559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.601 420.442) scale(35.213 35.2117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90D2FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72C7FB",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#57BCF7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40B3F4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2CACF2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1CA6F0",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#10A1EE",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#079EED",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#029CEC",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10235_10559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(225.101 310.085) scale(35.213 35.2117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90D2FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72C7FB",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#57BCF7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40B3F4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2CACF2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1CA6F0",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#10A1EE",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#079EED",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#029CEC",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10235_10559",
    x1: 143.621,
    y1: 211.558,
    x2: 190.028,
    y2: 265.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10235_10559",
    x1: 469.304,
    y1: 189.655,
    x2: 478.632,
    y2: 221.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10235_10559",
    x1: 454.155,
    y1: 185.29,
    x2: 463.732,
    y2: 216.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10235_10559",
    x1: 461.431,
    y1: 217.647,
    x2: 463.733,
    y2: 240.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10235_10559",
    x1: 446.105,
    y1: 213.228,
    x2: 448.505,
    y2: 235.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10235_10559",
    x1: 464.652,
    y1: 207.34,
    x2: 464.869,
    y2: 224.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10235_10559",
    x1: 449.092,
    y1: 202.857,
    x2: 449.309,
    y2: 220.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10235_10559",
    x1: 251.87,
    y1: 256.314,
    x2: 280.199,
    y2: 358.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10235_10559",
    x1: 360.74,
    y1: 349.745,
    x2: 366.467,
    y2: 366.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10235_10559",
    x1: 345.961,
    y1: 349.975,
    x2: 350.731,
    y2: 366.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10235_10559",
    x1: 448.302,
    y1: 320.997,
    x2: 465.287,
    y2: 366.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92D3FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10235_10559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 225,
    fill: "white",
    transform: "translate(135.312 183)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightImgV2);
export default __webpack_public_path__ + "static/media/right_img-v2.7751c00fd662bc82349ecf80dc59a49c.svg";
export { ForwardRef as ReactComponent };